<template>
  <div class="pl-7 pr-10 pb-6">
      <v-row>
        <v-col class="pl-0">
          <div class="primary1--text headline font-weight-bold">
            HIERARQUIA
          </div>
        </v-col>
      </v-row>
    <FiltroHierarquia
      v-model="showFiltro"
      @filtrar-hierarquia="filtro => changeFiltro(filtro)"
    />
    <v-row>
      <TabelaHierarquia
        :idUnimed="idUnimed"
        :idHierarquia="idHierarquia"
        @filtro-click="showFiltro = true"
        ref="hierarquiaAdm"
      />
    </v-row>

    <error-modal
      v-model="error"
      :errObj="errObj"
    />
  </div>
</template>

<script>
/* eslint-disable */

import TabelaHierarquia from "./Shared/TabelaHierarquia"

import FiltroHierarquia from "./Shared/FiltroHierarquia"

export default {
  components: {
    TabelaHierarquia,
    FiltroHierarquia
  },
  data() {
    return {
      showFiltro: false,
      loadingOverlay:false,
      error: false,
      errObj: {},
      idUnimed: '',
      idHierarquia: ''
    };
  },
  methods: {
    openFiltro(){
      this.showFiltro = true
    },
    changeFiltro(filtro) {
        this.idUnimed = filtro.idUnimed
        this.idHierarquia = filtro.idHierarquia

        this.$nextTick(() => {
          this.$refs.hierarquiaAdm.getHierarquias(1)
        })
    },
  }
};
</script>

<style></style>
